"use strict";
{
  const q1True = document.getElementById("q-1-true");
  const q1False = document.getElementById("q-1-false");
  const q2Dentist = document.getElementById("q-2-dentist");
  const q2dDoctor = document.getElementById("q-2-doctor");
  const modal = document.getElementById("modal");
  const modalQ1 = document.getElementById("modal-q-1");
  const modalQ2 = document.getElementById("modal-q-2");
  const mask = document.getElementById("mask");

  if (localStorage.getItem("confirm") !== null) {
    modal.classList.add("hidden");
    mask.classList.add("hidden");
  } else {
    modal.classList.remove("hidden");
    mask.classList.remove("hidden");
  }

  q1True.addEventListener("click", () => {
   modal.classList.add("hidden");
   mask.classList.add("hidden");
   localStorage.setItem("confirm", "yes");
 });
  q1False.addEventListener("click", () => {
    window.location.href = q1False.dataset.url;
  });

  q2Dentist.addEventListener("click", () => {
    modal.classList.add("hidden");
    mask.classList.add("hidden");
    if (localStorage.getItem("confirm")) {
      localStorage.removeItem("confirm");
      localStorage.setItem("confirm", "dentist");
    } else {
      localStorage.setItem("confirm", "dentist");
      }
  });
  q2dDoctor.addEventListener("click", () => {
    modal.classList.add("hidden");
    mask.classList.add("hidden");
    if (localStorage.getItem("confirm")) {
      localStorage.removeItem("confirm");
      localStorage.setItem("confirm", "doctor");
    } else {
      localStorage.setItem("confirm", "doctor");
      }
  });
}
